import { useState } from 'react';
import Router from 'next/router';

type NavigationType = 'push' | 'pop' | null;
let lastNavigationType: NavigationType = null;
let isInitialized = false;

/** 다음 네비게이션 체크를 위한 리셋 딜레이 (ms) */
const NAVIGATION_TYPE_RESET_DELAY_MS = 100;

// 핸들러를 모듈 레벨에 정의하여 HMR 시에도 동일 참조 유지
const popstateHandler = () => {
  lastNavigationType = 'pop';
};

const routeChangeStartHandler = () => {
  if (lastNavigationType !== 'pop') {
    lastNavigationType = 'push';
  }
};

const routeChangeCompleteHandler = () => {
  setTimeout(() => {
    lastNavigationType = null;
  }, NAVIGATION_TYPE_RESET_DELAY_MS);
};

const routeChangeErrorHandler = () => {
  lastNavigationType = null;
};

function initializeListeners() {
  if (isInitialized || typeof window === 'undefined') return;
  isInitialized = true;

  // 기존 리스너 제거 (HMR 대응)
  window.removeEventListener('popstate', popstateHandler);
  Router.events.off('routeChangeStart', routeChangeStartHandler);
  Router.events.off('routeChangeComplete', routeChangeCompleteHandler);
  Router.events.off('routeChangeError', routeChangeErrorHandler);

  // popstate는 브라우저 뒤로/앞으로가기 시 발생
  window.addEventListener('popstate', popstateHandler);

  // routeChangeStart는 모든 라우트 변경 시 발생
  // popstate 후에 발생하므로, 'pop'이 아닐 때만 'push'로 설정
  Router.events.on('routeChangeStart', routeChangeStartHandler);

  // routeChangeComplete에서 리셋
  Router.events.on('routeChangeComplete', routeChangeCompleteHandler);

  // routeChangeError에서도 리셋 (라우팅 실패/취소 시)
  Router.events.on('routeChangeError', routeChangeErrorHandler);
}

// 모듈 로드 시 초기화
initializeListeners();

/**
 * 브라우저 뒤로가기/앞으로가기(popstate) 여부를 감지하는 훅
 */
export const usePopStateDetector = () => {
  // 초기화 보장
  initializeListeners();

  const [isPopState] = useState(() => {
    // routeChangeComplete에서 리셋하므로 여기서는 리셋하지 않음
    return lastNavigationType === 'pop';
  });

  return isPopState;
};
